const version = '1.0.24'
const deployDate = '03/08/2026'

const dateFormat = 'YYYY-MM-DD'
const THEME_COLOR = '#ed2328'
const translations = {
    it: {
        norecordnots: 'Nessuna nota registrata',
        teamTrack: 'Gestione Team',
        analytics: 'Analisi dei dipendenti',
        employeeAnalyticsHeading: 'Analisi dei dipendenti',
        totalWorkHours: 'Ore totali lavorate',
        averageWorkHours: 'Ore lavorative medie giornaliere',
        breakTaken: 'Pausa effettuate',
        resumesBreak: 'Riprese delle pause',
        workedHours: 'Ore lavorate',
        dailyBreakTime: 'Tempo di pausa giornaliero',
        breakMinutes: 'Tempo di pausa',
        noWorkedHoursAvailable: 'Nessuna ora di lavoro disponibile',
        noBreakAvailable: 'Nessun dato sulle pause disponibile',
        resume: 'Riprendi',
        uploadExcel: "Clicca per caricare Excel",
        process: "Elaborazione...",
        Dashboard: 'Dashboard',
        Name: 'Nome',
        Surname: 'Cognome',
        WorkDay: 'Giornata Lavorativa',
        WorkingHours: 'Ore Lavorative',
        EntryTime: 'Orario Ingresso',
        ExitTime: 'Orario Uscita',
        EffectiveHours: 'Orario Effettivo',
        ExtraExpenses: 'Spese Extra',
        Lunch: 'Pranzo',
        SelectMeal: 'Seleziona tipo pasto',
        HotelExpense: 'Spesa Albergo',
        SelectHotel: 'Seleziona tipo albergo',
        Ferry: 'Traghetti',
        SelectFerry: 'Seleziona tipo traghetto',
        Telepass: 'Telepass (€)',
        Dinner: 'Cena (€)',
        KMTraveled: 'KM Percorsi',
        KMRate: 'Tariffa per Chilometro',
        TravelExpenses: 'Spese Viaggio (€)',
        Overtime: 'Straordinario (€)',
        Extra: 'Extra (€)',
        AddToLog: "Finalizzare l'immissione",
        EmployeeSheet: 'Foglio Presenze Dipendente',
        TrackHours: 'Traccia ore lavorative e spese',
        SelectWorkDate: 'Seleziona data lavorativa',
        SelectEntry: 'Seleziona orario ingresso',
        SelectExit: 'Seleziona orario uscita',
        PersonalInfo: 'Informazioni Personali',
        ExpenseRegister: 'Gestione della squadra',
        Logout: 'Disconnetti',
        addEdit: 'Aggiungi/Modifica Opzioni',
        dropdownOptions: 'Opzioni del Dropdown',
        noOptionsAvailable: 'Nessuna opzione disponibile',
        NewOption: 'Nuova Opzione',
        addNewOption: 'Aggiungi nuova opzione',
        cancel: 'Annulla',
        saveButton: 'Salva',
        updateButton: 'Aggiorna voce',
        enterYourName: 'Inserisci il tuo nome',
        employeeDashboard: "Cruscotto Dipendenti",
        trackAnalyze: "Traccia e analizza i registri di lavoro e le spese",
        dateRange: "Intervallo di Date",
        employee: "Dipendente",
        selectEmployees: "Seleziona dipendenti",
        totalHours: "Ore Totali",
        totalExpenses: "Spese Totali",
        overtime: "Straordinari",
        totalKm: "KM Totali",
        thisMonth: "Questo mese",
        last30Days: "Ultimi 30 giorni",
        timesheetRecords: "Registri Presenze Dipendenti",
        detailedView: "Vista dettagliata delle ore lavorate e spese giornaliere",
        exportPdf: "Esporta in PDF",
        exportExcel: "Esporta in Excel",
        excelReportDownload: "Report Excel scaricato con successo!",
        excelReportDownloadFailed: "Esportazione Excel fallita. Riprova più tardi.",
        googleCalendar: "Calendario Google",
        googleCalendarTitle: "Eventi del Calendario Google",
        noCalendarEvents: "Nessun evento trovato nell'intervallo di date selezionato.",
        allDay: "Tutto il giorno",
        connectedAs: "Connesso come",
        disconnectGoogle: "Disconnetti",
        openInGoogleCalendar: "Apri in Google Calendar",
        noTitle: "(Nessun titolo)",
        googleSignInFailed: "Accesso con Google non riuscito. Riprova.",
        googleCalendarFailed: "Impossibile caricare gli eventi di Google Calendar.",
        sharedCalendar: "condiviso",
        total: "Totale",
        enterYourSurname: "Inserisci il tuo cognome",
        users: "Dipendenti",
        userSubtitle: "Visualizza, gestisci e naviga nei record dettagliati dei dipendenti",
        addUser: "Aggiungi Dipendente",
        updateUser: "Aggiorna Dipendente",
        editUser: "Modifica Dipendente",
        userAdded: "Dipendente aggiunto con successo!",
        userUpdated: "Dipendente aggiornato con successo!",
        roleUpdated: "Ruolo aggiornato con successo!",
        fetchError: "Errore durante il recupero dei dipendenti",
        addUserError: "Errore durante l'aggiunta del dipendente",
        updateUserError: "Errore durante l'aggiornamento del dipendente",
        updateRoleError: "Errore durante l'aggiornamento del ruolo",
        name: "Nome",
        email: "Email",
        role: "Ruolo",
        actions: "Azioni",
        admin: "Amministratore",
        user: "Dipendente",
        nameReq: "Il nome è obbligatorio",
        emailReq: "L'email è obbligatoria",
        password: "Password",
        passwordReq: "La password è obbligatoria",
        enterName: "Inserisci il nome",
        enterEmail: "Inserisci l'email",
        enterPassword: "Inserisci la password",
        roleReq: "Il ruolo è obbligatorio",
        selectRole: "Seleziona ruolo",
        EstimationDashboard: "Dashboard Sistema di Stima",
        DashboardSubtitle: "Gestisci componenti, sistemi e calcola le stime dei costi per la tua flotta",
        GoBack: "Torna Indietro",
        Units: "Unità",
        Devices: "Dispositivi",
        TotalCost: "Costo Totale",
        CostEstimation: "Stima dei Costi",
        UnitsManagement: "Gestione Unità",
        DevicesManagement: "Gestione Dispositivi",
        vehiclesDashboard: "Dashboard Veicoli",
        vehiclesSubtitle: "Visualizza, gestisci e naviga tra i registri dettagliati dei veicoli",
        addVehicle: "Aggiungi Veicolo",
        editVehicle: "Modifica Veicolo",
        vehicleName: "Nome Veicolo",
        vehicleNameReq: "Inserisci il nome del veicolo",
        enterVehicleName: "Inserisci il nome del veicolo",
        licenseNumber: "Numero di Targa",
        licenseNumberReq: "Inserisci il numero di targa",
        enterLicenseNumber: "Inserisci il numero di targa del veicolo",
        registeringNumber: "Numero di Registrazione",
        registeringNumberReq: "Inserisci il numero di registrazione",
        enterRegisteringNumber: "Inserisci il numero di registrazione del veicolo",
        vehicleAdded: "Veicolo aggiunto con successo",
        vehicleUpdated: "Veicolo aggiornato con successo",
        vehicleDeleted: "Veicolo eliminato con successo",
        vehicleAddError: "Errore durante l'aggiunta del veicolo",
        vehicleUpdateError: "Errore durante l'aggiornamento del veicolo",
        vehicleDeleteError: "Errore durante l'eliminazione del veicolo",
        vehicleSaveError: "Errore durante il salvataggio del veicolo",
        fetchVehiclesError: "Errore durante il recupero dei veicoli",
        confirmDeleteVehicle: "Sei sicuro di voler eliminare questo veicolo?",
        yes: "Sì",
        no: "NO",
        vehicles: "Veicoli",
        totalVehicles: "Veicoli Totali",
        activeProjects: "Progetti Attivi",
        units: "Unità",
        unitPrice: "Prezzo unitario (MT/Pezzo)",
        total: "Totale",
        action: "Azione",
        perVehicle: "per veicolo",
        unitsQuantitiesCosts: "Quantità e Costi delle Unità",
        manageQuantitiesSubtitle: "Gestisci le quantità per ogni sistema del veicolo",
        updateEstimationError: "Aggiornamento della stima non riuscito",
        componentDeleted: "Componente eliminato con successo",
        deleteComponentError: "Eliminazione del componente non riuscita",
        addUnit: "Aggiungi Unità",
        addUnitSubtitle: "Aggiungi singole unità con prezzo",
        componentName: "Nome Componente",
        unitsLibrary: "Libreria Unità",
        unitsLibrarySubtitle: "Gestisci il tuo database delle unità",
        perUnit: "PREZZO AL MT/PZZ",
        unitAdded: "Unità aggiunta con successo",
        unitDeleted: "Unità eliminata con successo",
        unitAddError: "Errore durante l'aggiunta dell'unità",
        unitDeleteError: "Errore durante l'eliminazione dell'unità",
        fetchUnitsError: "Errore durante il caricamento delle unità",
        updatePriceError: "Errore durante l'aggiornamento del prezzo",
        addNewDevice: "Aggiungi Nuovo Dispositivo",
        addDeviceSubtitle: "Aggiungi un nuovo dispositivo del veicolo da tracciare",
        deviceName: "Nome Dispositivo",
        devicePlaceholder: "es. Telecamera laterale, Sensore movimento",
        color: "Colore",
        addDevice: "Aggiungi Dispositivo",
        currentDevice: "Dispositivo Attuale",
        currentDeviceSubtitle: "Gestisci i dispositivi del veicolo e le colonne",
        noDeviceFound: "Nessun dispositivo trovato",
        deviceAdded: "Dispositivo aggiunto con successo",
        deviceDeleted: "Dispositivo eliminato con successo",
        deviceAddError: "Errore durante l'aggiunta del dispositivo",
        deviceDeleteError: "Errore durante l'eliminazione del dispositivo",
        fetchDeviceError: "Errore durante il recupero del dispositivo",
        leaveManagement: "Gestione Permessi",
        leaveManagementSubtitle: "Rivedi, approva o rifiuta le richieste di permesso dei dipendenti",
        fetchLeavesError: "Errore durante il recupero dei permessi",
        updateLeaveStatusError: "Errore durante l'aggiornamento dello stato del permesso",
        leaveApprovedSuccess: "Richiesta di permesso approvata con successo",
        leaveRejectedSuccess: "Richiesta di permesso rifiutata con successo",
        approvedLeaves: "Permessi Approvati",
        pendingLeaves: "Permessi In Attesa",
        rejectedLeaves: "Permessi Rifiutati",
        totalRequests: "Richieste Totali",
        filterByEmployees: "Filtra per dipendenti",
        pending: "In Attesa",
        approved: "Approvato",
        rejected: "Rifiutato",
        loading: "Caricamento...",
        noRequests: "Nessuna richiesta di permesso {tab}",
        allCaughtUp: "Tutto a posto! Nessuna richiesta {tab} da rivedere.",
        dates: "Data/e:",
        appliedOn: "Richiesto il:",
        reason: "Motivo",
        showMore: "Mostra Altro",
        showLess: "Mostra Meno",
        approve: "Approva",
        reject: "Rifiuta",
        leaveRequest: "Richiesta Permesso",
        confirmLeaveAction: "Sei sicuro di voler {action} la richiesta di permesso di {name}?",
        fullDay: "(Giornata Intera)",
        myLeaveDashboard: "Dashboard Permessi Personali",
        myLeaveSubtitle: "Monitora le tue richieste di permesso, controlla lo stato di approvazione e gestisci facilmente le tue domande",
        applyForLeave: "Richiedi Permesso",
        approvedLeaves: "Permessi Approvati",
        pendingLeaves: "Permessi In Attesa",
        rejectedLeaves: "Permessi Rifiutati",
        thisMonth: "Questo Mese",
        approved: "Approvato",
        pending: "In Attesa",
        rejected: "Rifiutato",
        unknown: "Sconosciuto",
        dates: "Data/e:",
        appliedOn: "Richiesto il:",
        fullDay: "(Giornata Intera)",
        noLeaveRecords: "Nessun Permesso Trovato",
        noLeaveSubtitle: "Non hai ancora richiesto alcun permesso.",
        fetchLeavesError: "Errore durante il recupero dei permessi",
        paginationInfo: "Mostrando da {from} a {to} di {total} voci",
        perPage: "{count} per pagina",
        previous: "Precedente",
        next: "Successivo",
        pageInfo: "Pagina {page} di {pages}",
        leaveTypeLabel: "Tipo",
        vacation: "Vacanza",
        leave: "Permesso",
        vacationDateRange: "Intervallo Date Vacanza",
        vacationDateRequired: "Seleziona le date della vacanza",
        leaveDate: "Data Permesso",
        leaveDateRequired: "Seleziona la data del permesso",
        leaveDuration: "Durata Permesso",
        fullDay: "Giornata Intera",
        halfDay: "Mezza Giornata",
        timeRange: "Intervallo Orario",
        timeRangeRequired: "Seleziona l'intervallo orario",
        reason: "Motivo",
        reasonRequired: "Inserisci un motivo",
        reasonPlaceholder: "Inserisci il motivo",
        cancel: "Annulla",
        apply: "Applica",
        leaveAppliedSuccess: "Permesso richiesto con successo!",
        leaveApplyError: "Errore durante la richiesta di permesso",
        leaveSubmitError: "Errore durante l'invio della richiesta di permesso",
        employManagement: "Gestione Dipendenti",
        estimationSystem: "Sistema di Stima",
        employees: "Dipendenti",
        leaveManagement: "Gestione Permessi",
        myLeaves: "I miei Permessi",
        selectUnit: "Seleziona Unità",
        searchUser: "Cerca utente",
        lunchBreakInfo: 'Pausa pranzo (sottrai 1 ora)',
        lunchBreak: 'Pausa pranzo',
        lunch: 'Pranzo',
        dinner: 'Cena',
        hotel: 'Albergo',
        travel: 'Viaggio',
        extras: 'Extra',
        dayTotal: 'Totale Giornaliero',
        checkIn: "Entrata",
        checkOut: "Uscita",
        status: "Stato",
        completed: "Completato",
        working: "In Corso",
        action: "Azione",
        editEmployeeLog: "Modifica Registro Dipendente",
        applyForLeaveDrawer: "Richiedi Permesso",
        checkInEmployee: "Registra Dipendente",
        selectEmployeeToCheckIn: "Seleziona Dipendente da Registrare",
        currentTime: "Orario Attuale",
        breakDetails: "Dettagli della pausa",
        breakTime: "Tempo di pausa",
        enterManualTime: "Inserisci Orario Manuale",
        selectStartTime: "Seleziona Orario di Inizio",
        confirmCheckIn: "Conferma Registrazione",
        updateLog: "Aggiorna",
        settingHeading: 'Impostazioni',
        profileSetting: 'Profilo',
        securityfleSetting: 'Sicurezza',
        pleaseEnterYourNewpassword: 'Per favore, inserisci la tua nuova password!',
        passwordMustBeatleat: 'La password deve essere lunga almeno 8 caratteri!',
        confirlnewpassword: 'Conferma la nuova password',
        changePasswrdButton: 'Cambia password',
        newpassword: 'Nuova password',
        pleaseConfirmNewpassword: 'Per favore conferma la tua nuova password!',
        passwordDonotMatch: 'Le password non corrispondono!',
        saveChagnes: "Salva modifiche",
        goodWorkedToday: "Great job today!",
        deviceNameRequired: "Device Name Required!",
        pleaseSelectUnit: "Please Select Unit!",
        viewTimeDetails: "Visualizza i dettagli dell'ora",
        activeWorkSession: "Sessione di lavoro attiva",
        hello: "Ciao",
        goodMorning: "Buongiorno",
        goodEvening: "Buonasera",
        goodAfterNoon: "Buon pomeriggio",
        youHaveWorked: "Hai lavorato!",
        workingSince: "lavorando da allora",
        hour: "Ore",
        minutes: "minuti",
        seconds: "secondi",
        youHaveMissedCheckout: "mancato pagamento",
        missed: "Mancato",
        addUserWorkEntry: "Aggiungi voce di lavoro del dipendente",
        noRecordFoundPleaseAddManually: "Nessuna voce trovata, aggiungere la voce di lavoro del dipendente",
        failedToFetchEmployeeEntry: "Impossibile recuperare la voce del dipendente",
        pleaseSelectBothEntryAndExitTime: "Seleziona sia l'orario di entrata che quello di uscita",
        entryTimeAndExittTimeCannotBeTheSame: "L'orario di entrata e l'orario di uscita non possono essere uguali",
        entryTimeMustBeBeforeExitTime: "L'orario di ingresso deve essere precedente all'orario di uscita",
        workLogAddedSuccessfully: 'Registro di lavoro aggiunto con successo',
        pleaseSelectDate: 'Seleziona la data',
        pleaseSelectDateAndEmployee: 'Seleziona la data e il dipendente',
        totalWorked: 'Totale ore lavorate',
        breaks: 'Pause',
        break: 'Pausa',
        breakStarted: 'Pausa iniziata',
        breakEnded: 'Pausa terminata',
        duration: 'Durata',
        noBreaksRecorded: 'Nessuna pausa registrata',
        pleaseSelectEntryTime: 'Seleziona l’orario di entrata',
        pleaseSelectExitTime: 'Seleziona l’orario di uscita',
        exitTimeMustBeGreaterThanEntryTime: "L'orario di uscita deve essere successivo all'orario di entrata",
        breakStartMustBeBetweenEntryAndExitTime: "L'inizio della pausa deve essere tra l'entrata e l'uscita",
        breakEndMustBeBetweenEntryAndExitTime: "La fine della pausa deve essere tra l'entrata e l'uscita",
        breakEndCannotBeTheSameAsBreakStart: "La fine della pausa non può coincidere con l'inizio",
        breakStartOverlapsWithAnotherBreak: "L'inizio della pausa si sovrappone a un’altra pausa",
        breakEndOverlapsWithAnotherBreak: "La fine della pausa si sovrappone a un’altra pausa",
        breakEndMustBeGreaterThanBreakStart: "La fine della pausa deve essere successiva all'inizio",
        startTimeRequired: "Orario di inizio richiesto",
        totalBreakTime: "Tempo di pausa totale",
        endTimeRequired: "Orario di fine richiesto",
        start: "Inizio",
        end: "Fine",
        currentlyOnBreak: "Attualmente in pausa",
        yourWorkRecordOn: "Il tuo registro di lavoro del",
        addBreak: "Aggiungi pausa",
        currentlyOnWorkingEntryTime: "Attualmente in fase di ingresso",
        BreakStartedSuccessfully: "La pausa è iniziata con successo!",
        WorkResumedSuccessfully: "Pausa ripresa con successo!",
        worked: "lavorato",
        budgetEstimation: "Stima del budget",
        noCheckout: "Uscita non registrata",
        clockedInAt: "Entrata",
        testingPhaseTitle: "Piattaforma in fase di test",
        testingPhaseMsg: "Stiamo testando una nuova piattaforma per la registrazione dei timbri. Durante questa fase di test, ti chiediamo gentilmente di continuare a timbrare l'entrata, la pausa, il rientro e l'uscita, in modo da poter verificare che il sistema funzioni correttamente. I dati registrati in questo periodo non verranno utilizzati in alcun modo, ma solo per verificare che tutto funzioni come previsto. Per qualsiasi domanda o dubbio, contatta l'ufficio amministrativo. Grazie per la collaborazione!",
        workingHours: "Orario di lavoro",
        endBreakTime: "Fine della pausa",
        startBreakTime: "Inizia la pausa",
        date: 'Data',
        employeAnalyticsParagraph: 'Monitora, analizza e visualizza le ore di lavoro e le pause dei dipendenti',
        map: 'Mappa',
        mint: "menta",
        vacation: "Vacanza",
        leave: "Partire",
        startDate: "Data di inizio",
        endDate: "Data di fine",
        selectDate: "Seleziona Data",
        confirmBreak: "Conferma pausa",
        confirmResume: "Conferma riprendi",
        amount: "€ quantità",
        distanceInKm: "distanza in km",
        kmRatePlaceholder: "€/km tariffa ",
        resumeWork: "Riprendere il lavoro",
        notes: 'Note',
        writeDone: 'Annota i tuoi compiti o eventuali aggiornamenti importanti per oggi...',
        dailyremarks: 'Osservazioni quotidiane:',
        previousnotes: 'Registrazione della nota precedente:',
        addNotes: 'Aggiungi nuova nota',
        updateNotes: 'Aggiorna le tue note',
        viewDaySummary: 'Visualizza il riepilogo del giorno',

        nonotes: 'Nessuna nota è stata registrata per questa data',
        clickToOpenNote: 'Clicca per aprire la nota completa',
        saveChanges: 'Salva modifiche',
        submitnotes: 'Invia nota',
        workedOn: 'ha lavorato',
        qualityUser: 'Utente di Qualità',
        loadingMap: 'Caricamento mappa',
        startBreak: "Inizio pausa",
        update: "Aggiornamento",
        hrs: "ore",
        selectTime: "Seleziona l'ora",
        superAdmin: "Super amministratore",
        pleaseEnterName: "Inserisci il tuo nome",
        profileUpdated: "Profilo aggiornato con successo",
        passwordChanged: "Password modificata con successo",
        unexpectedError: "Si è verificato un errore imprevisto. Riprova.",
        noData: "Nessun dato",
        january: "Gennaio",
        february: "Febbraio",
        march: "Marzo",
        april: "Aprile",
        may: "Maggio",
        june: "Giugno",
        july: "Luglio",
        august: "Agosto",
        september: "Settembre",
        october: "Ottobre",
        november: "Novembre",
        december: "Dicembre",
        blue: "Blu",
        green: "Verde",
        purple: "Viola",
        red: "Rosso",
        orange: "Arancione",
        gray: "Grigio",
        deleteMsg: "Sei sicuro di voler eliminare?",
        employeeReportDownload: "Rapporto dipendenti scaricato con successo!",
        employeeReportDownloadFailed: "Esportazione del PDF fallita. Riprova più tardi.",
        vehicleReportDownload: "Rapporto di stima scaricato con successo!",
        vehicleReportDownloadFailed: "Esportazione del PDF di stima non riuscita. Per favore riprova più tardi.",
        leaveReportDownload: "Rapporto delle ferie scaricato con successo!",
        leaveReportDownloadFailed: "Esportazione del PDF delle ferie non riuscita. Per favore riprova più tardi.",
    },

    en: {
        leaveReportDownloadFailed: "Failed to export leaves PDF. Please try again later.",
        leaveReportDownload: "Leaves report downloaded successfully!",
        vehicleReportDownloadFailed: "Failed to export estimation PDF. Please try again later.",
        vehicleReportDownload: "Estimation report downloaded successfully!",
        employeeReportDownloadFailed: "Failed to export PDF. Please try again later.",
        employeeReportDownload: "Employee report downloaded successfully!",
        deleteMsg: "Are you sure you want to delete?",
        blue: "Blue",
        green: "Green",
        purple: "Purple",
        red: "Red",
        orange: "Orange",
        gray: "Gray",
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December",
        selectTime: "Select Time",
        superAdmin: "Super Admin",
        pleaseEnterName: "Please enter your name",
        profileUpdated: "Profile updated successfully",
        passwordChanged: "Password changed successfully",
        unexpectedError: "Unexpected error occurred. Please try again.",
        noData: "No data",
        hrs: "hrs",
        update: "Update",
        startBreak: "Start Break",
        loadingMap: 'Loading map',
        qualityUser: 'Quality User',
        workedOn: 'worked On',
        nonotes: 'No notes were recorded for this date.',
        clickToOpenNote: 'Click to open the full note',
        saveChanges: 'Save Changes',
        submitnotes: 'Submit Note',


        notes: 'Notes',
        addNotes: 'Add New Note',
        updateNotes: 'Update Your Notes',
        viewDaySummary: 'View Day Summary',
        previousnotes: 'Previous Note Record:',
        dailyremarks: 'Daily Remarks:',
        writeDone: 'Write down your tasks or any important updates for today...',
        norecordnots: 'No notes recorded',
        resumeWork: "Resume Work",
        kmRatePlaceholder: "€/km rate",
        distanceInKm: "distance in km",
        amount: "€ amount",
        confirmResume: "Confirm Resume",
        confirmBreak: "Confirm Break",
        selectDate: "Select Date",
        endDate: "End Date",
        startDate: "Start Date",
        leave: "Leave",
        vacation: "Vacation",
        mint: "mint",
        teamTrack: 'Team Track',
        employeAnalyticsParagraph: 'Track, analyze, and visualize employee working hours and breaks',
        analytics: 'Employee Analytics',
        employeeAnalyticsHeading: 'Employee Analytics',
        totalWorkHours: 'Total Hours Worked',
        averageWorkHours: 'Average Daily Hours',
        breakTaken: 'Breaks Taken',
        resumesBreak: 'Resumes',
        workedHours: 'Worked Hours',
        dailyBreakTime: 'Daily Break Time',
        breakMinutes: 'Break Time',
        noWorkedHoursAvailable: 'No worked hours available',
        noBreakAvailable: 'No break data available',

        date: 'Date',
        map: 'Map',
        endBreakTime: "End break time",
        startBreakTime: "Start break time",
        SelectWorkDate: "Select Working Date",
        workingHours: "Working Hours",
        testingPhaseTitle: "Platform in Testing Phase",
        testingPhaseMsg: "We are testing a new platform for recording time stamps. During this testing phase, we kindly ask you to still clock in, break, return, and exit so we can verify the system is functioning properly. The data recorded during this period will not be used in any way, but only to verify that everything is working as expected. For any questions or concerns, please contact the administration office. Thank you for your cooperation!",
        process: "Processing...",
        uploadExcel: "Click to upload excel",
        qualityUser: "Quality User",
        missed: "Missed",
        saveChagnes: "Save Changes",
        pleaseEnterYourNewpassword: 'Please enter your new password!',
        passwordMustBeatleat: 'Password must be at least 8 characters!',
        confirlnewpassword: 'Confirm New Password',
        changePasswrdButton: 'Change Password',
        pleaseConfirmNewpassword: 'Please confirm your new password!',
        passwordDonotMatch: 'Passwords do not match!',
        newpassword: 'New Password',
        profileSetting: 'Profile',
        securityfleSetting: 'Security',
        settingHeading: 'Settings',
        updateLog: "Update",
        status: "Status",
        completed: "Completed",
        working: "Working",
        action: "Action",
        editEmployeeLog: "Edit Employee Log",
        applyForLeaveDrawer: "Apply for Leave",
        checkInEmployee: "Check In Employee",
        selectEmployeeToCheckIn: "Select Employee to Check In",
        currentTime: "Current Time",
        breakDetails: "Break Details",
        breakTime: "Break Time",
        enterManualTime: "Enter Manual Time",
        selectStartTime: "Select Start Time",
        confirmCheckIn: "Confirm Check In",
        checkIn: "Entry",
        checkOut: "Exit",
        dayTotal: 'Total Daily',
        extras: 'Extras',
        travel: 'Travel',
        hotel: 'Hotel',
        dinner: 'Dinner',
        lunch: 'Lunch',
        lunchBreak: 'Lunch break',
        lunchBreakInfo: 'Lunch break (subtract 1 hour)',
        searchUser: "Search Users",
        selectUnit: "Select Unit",
        employManagement: "Employee Management",
        estimationSystem: "Estimation System",
        employees: "Employees",
        leaveManagement: "Leave Management",
        myLeaves: "My Leaves",
        leaveTypeLabel: "Type",
        vacation: "Vacation",
        leave: "Leave",
        vacationDateRange: "Vacation Date Range",
        vacationDateRequired: "Please select vacation dates",
        leaveDate: "Leave Date",
        leaveDateRequired: "Please select leave date",
        leaveDuration: "Leave Duration",
        fullDay: "Full Day",
        halfDay: "Half Day",
        timeRange: "Time Range",
        timeRangeRequired: "Please select time range",
        reason: "Reason",
        reasonRequired: "Please provide a reason",
        reasonPlaceholder: "Enter reason",
        cancel: "Cancel",
        apply: "Apply",
        leaveAppliedSuccess: "Leave applied successfully!",
        leaveApplyError: "Failed to apply leave",
        leaveSubmitError: "Error submitting leave request",
        myLeaveDashboard: "My Leave Dashboard",
        myLeaveSubtitle: "Track your leave requests, check approval status and manage your applications easily",
        applyForLeave: "Apply for Leave",
        approvedLeaves: "Approved Leaves",
        pendingLeaves: "Pending Leaves",
        rejectedLeaves: "Rejected Leaves",
        thisMonth: "This Month",
        approved: "Approved",
        pending: "Pending",
        rejected: "Rejected",
        unknown: "Unknown",
        dates: "Date(s):",
        appliedOn: "Applied On:",
        fullDay: "(Full Day)",
        noLeaveRecords: "No Leave Records Found",
        noLeaveSubtitle: "You haven't applied for any leaves yet.",
        fetchLeavesError: "Failed to fetch leaves",
        paginationInfo: "Showing {from} to {to} of {total} entries",
        perPage: "{count} per page",
        previous: "Previous",
        next: "Next",
        pageInfo: "Page {page} of {pages}",
        leaveManagement: "Leave Management",
        leaveManagementSubtitle: "Review, approve or reject employee leave requests",
        fetchLeavesError: "Failed to fetch leaves",
        updateLeaveStatusError: "Error updating leave status",
        leaveApprovedSuccess: "Leave request approved successfully",
        leaveRejectedSuccess: "Leave request rejected successfully",
        approvedLeaves: "Approved Leaves",
        pendingLeaves: "Pending Leaves",
        rejectedLeaves: "Rejected Leaves",
        totalRequests: "Total Requests",
        filterByEmployees: "Filter by employees",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        loading: "Loading...",
        noRequests: "No {tab} leave requests",
        allCaughtUp: "All caught up! No {tab} requests to review.",
        dates: "Date(s):",
        appliedOn: "Applied On:",
        reason: "Reason",
        showMore: "Show More",
        showLess: "Show Less",
        approve: "Approve",
        reject: "Reject",
        leaveRequest: "Leave Request",
        confirmLeaveAction: "Are you sure you want to {action} {name}'s leave request?",
        fullDay: "(Full Day)",
        addNewDevice: "Add New Device",
        addDeviceSubtitle: "Add new vehicle Device to track",
        deviceName: "Device Name",
        devicePlaceholder: "e.g., Side Camera, Motion Sensor",
        color: "Color",
        addDevice: "Add Device",
        currentDevice: "Current Device",
        currentDeviceSubtitle: "Manage your vehicle Device and columns",
        noDeviceFound: "No Device found",
        deviceAdded: "Device added successfully",
        deviceDeleted: "Device deleted successfully",
        deviceAddError: "Failed to add device",
        deviceDeleteError: "Failed to delete device",
        fetchDeviceError: "Failed to fetch Device",
        addUnit: "Add Unit",
        addUnitSubtitle: "Add individual Units with price",
        componentName: "Component Name",
        unitPrice: "Unit Price (MT/Piece)",
        unitsLibrary: "Units Library",
        unitsLibrarySubtitle: "Manage your Units database",
        perUnit: "PRICE PER MT/PIECE",
        unitAdded: "Unit added successfully",
        unitDeleted: "Unit deleted successfully",
        unitAddError: "Failed to add Unit",
        unitDeleteError: "Failed to delete Unit",
        fetchUnitsError: "Failed to load units",
        updatePriceError: "Failed to update price",
        units: "Units",
        total: "Total",
        action: "Action",
        perVehicle: "per vehicle",
        unitsQuantitiesCosts: "Units Quantities & Costs",
        manageQuantitiesSubtitle: "Manage quantities for each vehicle system",
        updateEstimationError: "Failed to update estimation",
        componentDeleted: "Component deleted successfully",
        deleteComponentError: "Failed to delete component",
        vehiclesDashboard: "Vehicles Dashboard",
        vehiclesSubtitle: "View, manage and navigate to detailed vehicle records",
        addVehicle: "Add Vehicle",
        editVehicle: "Edit Vehicle",
        vehicleName: "Vehicle Name",
        vehicleNameReq: "Please input vehicle name",
        enterVehicleName: "Enter Vehicle Name",
        licenseNumber: "License Number",
        licenseNumberReq: "Please input license number",
        enterLicenseNumber: "Enter Vehicle License Number",
        registeringNumber: "Registering Number",
        registeringNumberReq: "Please input registering number",
        enterRegisteringNumber: "Enter Vehicle Registration Number",
        vehicleAdded: "Vehicle added successfully",
        vehicleUpdated: "Vehicle updated successfully",
        vehicleDeleted: "Vehicle deleted successfully",
        vehicleAddError: "Failed to add vehicle",
        vehicleUpdateError: "Failed to update vehicle",
        vehicleDeleteError: "Failed to delete vehicle",
        vehicleSaveError: "Error saving vehicle",
        fetchVehiclesError: "Error fetching vehicles",
        confirmDeleteVehicle: "Are you sure to delete this vehicle?",
        yes: "Yes",
        no: "No",
        vehicles: "Vehicles",
        totalVehicles: "Total Vehicles",
        activeProjects: "Active Projects",
        EstimationDashboard: "Estimation System Dashboard",
        DashboardSubtitle: "Manage components, systems and calculate cost estimations for your fleet",
        GoBack: "Go Back",
        Units: "Units",
        Devices: "Devices",
        TotalCost: "Total Cost",
        CostEstimation: "Cost Estimation",
        UnitsManagement: "Units Management",
        DevicesManagement: "Devices Management",
        enterYourSurname: "Enter your surname",
        Dashboard: 'Dashboard',
        Name: 'Name',
        Surname: 'Surname',
        WorkDay: 'Work Day',
        WorkingHours: 'Working Hours',
        EntryTime: 'Entry Time',
        ExitTime: 'Exit Time',
        EffectiveHours: 'Effective Hours',
        ExtraExpenses: 'Extra Expenses',
        Lunch: 'Lunch',
        SelectMeal: 'Select meal type',
        HotelExpense: 'Hotel Expense',
        SelectHotel: 'Select hotel type',
        Ferry: 'Ferries',
        SelectFerry: 'Select ferry type',
        Telepass: 'Telepass (€)',
        Dinner: 'Dinner (€)',
        KMTraveled: 'KM Traveled',
        KMRate: 'Kilometer Rate',
        TravelExpenses: 'Travel Expenses (€)',
        Overtime: 'Overtime (€)',
        Extra: 'Extra (€)',
        AddToLog: 'Finalize Entry',
        EmployeeSheet: 'Employee Timesheet',
        TrackHours: 'Track working hours and expenses',
        SelectWorkDate: 'Select work date',
        SelectEntry: 'Select entry time',
        SelectExit: 'Select exit time',
        PersonalInfo: 'Personal Information',
        ExpenseRegister: 'Team Management',
        Logout: 'Logout',
        addEdit: 'Add/Edit Options',
        dropdownOptions: 'Dropdown Options',
        noOptionsAvailable: 'No options available',
        NewOption: 'New Option',
        addNewOption: 'Add new option',
        cancel: 'Cancel',
        saveButton: 'Save',
        updateButton: 'Update entry',
        enterYourName: 'Enter your name',
        employeeDashboard: "Employee Dashboard",
        trackAnalyze: "Track and analyze employee work logs and expenses",
        dateRange: "Date Range",
        employee: "Employee",
        selectEmployees: "Select employees",
        totalHours: "Total Hours",
        totalExpenses: "Total Expenses",
        overtime: "Overtime",
        totalKm: "Total KM",
        thisMonth: "This month",
        last30Days: "Last 30 days",
        timesheetRecords: "Employee Timesheet Records",
        detailedView: "Detailed view of daily work hours and expenses",
        exportPdf: "Export as PDF",
        exportExcel: "Export as Excel",
        excelReportDownload: "Excel report downloaded successfully!",
        excelReportDownloadFailed: "Failed to export Excel. Please try again later.",
        googleCalendar: "Google Calendar",
        googleCalendarTitle: "Google Calendar Events",
        noCalendarEvents: "No events found in the selected date range.",
        allDay: "All day",
        connectedAs: "Connected as",
        disconnectGoogle: "Disconnect",
        openInGoogleCalendar: "Open in Google Calendar",
        noTitle: "(No title)",
        googleSignInFailed: "Google sign-in failed. Please try again.",
        googleCalendarFailed: "Failed to load Google Calendar events.",
        sharedCalendar: "shared",
        total: "Total",
        users: "Employees",
        userSubtitle: "View, manage and navigate to detailed employee records",
        addUser: "Add Employee",
        updateUser: "Update Employee",
        editUser: "Edit Employee",
        userAdded: "Employee added successfully!",
        userUpdated: "Employee updated successfully!",
        roleUpdated: "Role updated successfully!",
        fetchError: "Error fetching employees",
        addUserError: "Error adding employee",
        updateUserError: "Error updating employee",
        updateRoleError: "Error updating role",
        name: "Name",
        email: "Email",
        role: "Role",
        actions: "Actions",
        admin: "Admin",
        user: "Employee",
        nameReq: "Name is required",
        emailReq: "Email is required",
        password: "Password",
        passwordReq: "Password is required",
        enterName: "Enter name",
        enterEmail: "Enter email",
        enterPassword: "Enter password",
        roleReq: "Role is required",
        selectRole: "Select role",
        goodWorkedToday: "Great job today!",
        deviceNameRequired: "Device Name Required!",
        pleaseSelectUnit: "Please Select Unit!",
        viewTimeDetails: "View time Details",
        activeWorkSession: "Active Work Session",
        hello: "Hello",
        goodMorning: "Good Morning",
        goodEvening: "Good Evening",
        goodAfterNoon: "Good Afternoon",
        youHaveWorked: "You Have Worked!",
        workingSince: "Working Since",
        hour: "Hours",
        minutes: "Minutes",
        seconds: "Seconds",
        youHaveMissedCheckout: "Missed Checkout",
        resume: 'Resume',
        addUserWorkEntry: 'Add Employee Work Entry',
        noRecordFoundPleaseAddManually: 'No entry found, please add employee work entry',
        failedToFetchEmployeeEntry: 'Failed to fetch employee entry',
        pleaseSelectBothEntryAndExitTime: 'Please select both entry and exit time',
        entryTimeAndExittTimeCannotBeTheSame: 'Entry time and exit time cannot be the same',
        entryTimeMustBeBeforeExitTime: 'Entry time must be before exit time',
        workLogAddedSuccessfully: 'Work log added successfully',
        pleaseSelectDate: 'Select Date',
        pleaseSelectDateAndEmployee: 'Please Select Date And Employee',
        totalWorked: 'Total Worked',
        breaks: 'Breaks',
        break: 'Break',
        breakStarted: 'Break Started',
        breakEnded: 'Break Ended',
        duration: 'duration',
        noBreaksRecorded: 'No breaks recorded',
        pleaseSelectEntryTime: 'Please select entry time',
        pleaseSelectExitTime: 'Please select exit time',
        exitTimeMustBeGreaterThanEntryTime: 'Exit time must be greater than entry time',
        breakStartMustBeBetweenEntryAndExitTime: 'Break start must be between entry and exit time',
        breakEndMustBeBetweenEntryAndExitTime: 'Break end must be between entry and exit time',
        breakEndCannotBeTheSameAsBreakStart: 'Break end cannot be the same as break start',
        breakStartOverlapsWithAnotherBreak: 'Break start overlaps with another break',
        breakEndOverlapsWithAnotherBreak: 'Break end overlaps with another break',
        breakEndMustBeGreaterThanBreakStart: 'Break end must be greater than break start',
        startTimeRequired: 'Start time required',
        totalBreakTime: 'Total Break Time',
        endTimeRequired: 'End time required',
        start: 'Start',
        end: 'End',
        currentlyOnBreak: 'Currently On Break',
        yourWorkRecordOn: 'Your Work Record on',
        addBreak: 'Add Break',
        currentlyOnWorkingEntryTime: 'Currently on working Entry Time',
        BreakStartedSuccessfully: 'Break started successfully!',
        WorkResumedSuccessfully: 'Break Resumed successfully!',
        worked: 'worked',
        budgetEstimation: 'Budget Estimation',
        noCheckout: 'No check-out recorded',
        clockedInAt: 'Clocked in',

    }
}


export {
    translations,
    version,
    deployDate,
    dateFormat,
    THEME_COLOR
}
